import { render, staticRenderFns } from "./CourseTableRow.vue?vue&type=template&id=3c0f2b60&"
import script from "./CourseTableRow.vue?vue&type=script&lang=js&"
export * from "./CourseTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports